import { Container, Divider, SkeletonText, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { useLocation, useParams } from 'react-router-dom';
import CompanyHeader from '../components/CompanyHeader';
import CompanyRecipientsList from '../components/CompanyRecipientsList';
import FormCompany from '../components/FormCompany';
import CompaniesProvider from '../contexts/CompaniesContext';
import { useCompany } from '../hooks/useCompany';

export default function PageEditCompany() {
  const { id, tab } = useParams();
  const location = useLocation();
  const { isFetched, data: company } = useCompany(id);

  const isLoaded = isFetched && !!company;

  const index = tab === 'membros' ? 1 : 0;

  return (
    <Tabs defaultIndex={index} variant="line">
      <HeaderBarInternal
        title="Editar cliente"
        backTo={`/clientes${location.search}`}
      >
        <TabList>
          <Tab>Dados da Empresa</Tab>
          <Tab>Membros</Tab>
        </TabList>
      

        <CompanyHeader company={company} />
      </HeaderBarInternal>

      <Divider />

      <Container flexDirection="column">
        <SkeletonText isLoaded={isLoaded}>
        { company && (
          <CompaniesProvider companyId={company.id}>
            <TabPanels>
              <TabPanel>
                <FormCompany company={company} />
              </TabPanel>
              <TabPanel>
                <CompanyRecipientsList company={company} />
              </TabPanel>
            </TabPanels>
          </CompaniesProvider>
        )}
        </SkeletonText>
      </Container>
    </Tabs>
  );
}
